// src/pages/AdminLogin.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@carbonbridge.cloud");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/admin";

  React.useEffect(() => {
    if (isAuthenticated) navigate(from, { replace: true });
  }, [isAuthenticated, from, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    console.log("Login attempt", { email, password });
    const res = await login({ email, password });
    console.log("Login response", res);
    if (!res.ok) {
      setError(res.error || "Login failed");
      console.log("Login failed", res.error);
    } else {
      console.log("Login success, navigating to", from);
      navigate(from, { replace: true });
    }
  };

  return (
    <Container sx={{ py: 8 }}>
      <Paper sx={{ maxWidth: 420, mx: "auto", p: 4 }}>
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
          Admin Login
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
          Access the Carbon Registry admin console.
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && (
            <Typography
              variant="body2"
              color="error"
              sx={{ mt: 1, mb: 1.5 }}
            >
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 1.5, borderRadius: 999 }}
          >
            Log in
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
